// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  --bg: #f5f7fb;
  --surface: #ffffff;
  --surface-2: #f0f3f9;
  --border: #d8dde6;
  --text: #1a1f2c;
  --text-muted: #5d6679;
  --accent: #2f6bff;
  --accent-fg: #ffffff;
  --error: #d92d2d;
  --success: #16a34a;
  --warning: #b97a00;
  --radius: 8px;
  --shadow: 0 4px 14px rgba(20, 30, 60, 0.08);
  /* Единственная (светлая) цветовая схема: тёмная тема и адаптация по
     prefers-color-scheme убраны. Цвета piano roll — константы
     \`PIANO_ROLL_COLORS\` (см. app/src/pianoRollColors.ts). */
  color-scheme: light;
}

* {
  box-sizing: border-box;
}

html, body {
  margin: 0;
  padding: 0;
  background: var(--bg);
  color: var(--text);
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", sans-serif;
  font-size: 14px;
  line-height: 1.5;
}

#root {
  min-height: 100vh;
}

.app {
  width: 100%;
  margin: 0;
  padding: 24px clamp(16px, 4vw, 48px);
}

.app__header {
  margin-bottom: 24px;
}

.app__header h1 {
  margin: 0 0 4px;
  font-size: 24px;
  font-weight: 700;
}

.app__header p {
  margin: 0;
  color: var(--text-muted);
}

.app__version {
  display: inline-block;
  margin-top: 6px;
  padding: 2px 8px;
  border: 1px solid var(--border);
  border-radius: 999px;
  font-size: 11px;
  line-height: 1.4;
  color: var(--text-muted);
  user-select: all;
}

/* Dev-сборка (\`webpack serve --mode development\`): плашка инвертирована,
   чтобы визуально отличать dev от prod. Модификатор вешается в App.tsx
   по \`IS_DEV\` из config.ts (DefinePlugin → process.env.IS_DEV). */
.app__version--dev {
  background: var(--accent);
  border-color: var(--accent);
  color: var(--accent-fg);
}

.app__main {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.app__results {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.app__results-head {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 12px 16px;
  background: var(--surface);
  border: 1px solid var(--border);
  border-radius: var(--radius);
}

.app__results-actions {
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
}

.app__grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 16px;
}

@media (max-width: 1024px) {
  .app__grid {
    grid-template-columns: 1fr;
  }
}

.dropzone {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 8px;
  padding: 48px 24px;
  background: var(--surface);
  border: 2px dashed var(--border);
  border-radius: var(--radius);
  text-align: center;
  transition: border-color 0.15s ease;
}

.dropzone--hover {
  border-color: var(--accent);
}

.dropzone--disabled {
  opacity: 0.7;
  pointer-events: none;
}

.dropzone__title {
  margin: 0;
  font-size: 16px;
  font-weight: 500;
}

.dropzone__hint {
  margin: 0;
  color: var(--text-muted);
  font-size: 13px;
}

.card {
  background: var(--surface);
  border: 1px solid var(--border);
  border-radius: var(--radius);
  padding: 16px;
  box-shadow: var(--shadow);
}

.card--highlight {
  border-color: var(--accent);
}

.card__title {
  margin: 0 0 12px;
  font-size: 14px;
  font-weight: 600;
  color: var(--text-muted);
  text-transform: uppercase;
  letter-spacing: 0.04em;
}

.kv {
  display: grid;
  grid-template-columns: 110px 1fr;
  gap: 4px 12px;
  margin: 0;
}

.kv dt {
  color: var(--text-muted);
}

.kv dd {
  margin: 0;
}

.kv__hint {
  color: var(--text-muted);
  font-size: 12px;
}

.kv__diff {
  grid-column: 2;
  margin: 4px 0 0;
  padding: 6px 10px;
  border-left: 3px solid var(--warning);
  background: color-mix(in srgb, var(--warning) 10%, transparent);
  color: var(--text);
  font-size: 13px;
  border-radius: 4px;
}

.kv__alts {
  grid-column: 2;
  margin: 4px 0 0;
  padding: 0;
  list-style: none;
  color: var(--text-muted);
  font-size: 12px;
}

.table-wrap {
  overflow-x: auto;
}

.track-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 13px;
}

.track-table th,
.track-table td {
  padding: 6px 8px;
  text-align: left;
  border-bottom: 1px solid var(--border);
  vertical-align: top;
}

.track-table th {
  color: var(--text-muted);
  font-weight: 500;
  font-size: 12px;
  text-transform: uppercase;
  letter-spacing: 0.04em;
}

.track-row--empty {
  color: var(--text-muted);
  background: var(--surface-2);
}

.muted {
  color: var(--text-muted);
  font-size: 12px;
}

.btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  padding: 8px 14px;
  border: 1px solid var(--border);
  background: var(--surface-2);
  color: var(--text);
  border-radius: 6px;
  font-size: 13px;
  cursor: pointer;
  text-decoration: none;
  font-family: inherit;
  transition: background 0.15s ease, border-color 0.15s ease;
}

.btn:hover:not(:disabled) {
  border-color: var(--accent);
}

.btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.btn--primary {
  background: var(--accent);
  border-color: var(--accent);
  color: var(--accent-fg);
}

.btn--primary:hover:not(:disabled) {
  filter: brightness(1.1);
}

.btn--ghost {
  background: transparent;
}

.banner {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 10px 14px;
  border-radius: var(--radius);
  border: 1px solid var(--border);
  background: var(--surface);
}

.banner--error {
  border-color: var(--error);
  color: var(--error);
}

.gear-icon {
  position: absolute;
  top: 24px;
  right: clamp(16px, 4vw, 48px);
  background: transparent;
  border: 1px solid var(--border);
  border-radius: 6px;
  padding: 6px 10px;
  font-size: 18px;
  line-height: 1;
  cursor: pointer;
  color: var(--text);
}

.gear-icon:hover {
  border-color: var(--accent);
}

.app__header {
  position: relative;
}

.op-toolbar {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.op-toolbar__row {
  display: flex;
  align-items: center;
  gap: 12px;
  flex-wrap: wrap;
}

.op-toolbar__row--column {
  flex-direction: column;
  align-items: flex-start;
  gap: 6px;
}

.op-toolbar__group-label {
  color: var(--text-muted);
  font-size: 12px;
  text-transform: uppercase;
  letter-spacing: 0.04em;
}

.op-toolbar__toggle,
.op-toolbar__check {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  font-size: 13px;
  cursor: pointer;
}

.accordion__item {
  border-top: 1px solid var(--border);
}

.accordion__item:first-child {
  border-top: none;
}

.accordion__item--empty .accordion__title {
  color: var(--text-muted);
}

.accordion__head {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 8px 4px;
  cursor: pointer;
  user-select: none;
}

.accordion__head:hover {
  background: var(--surface-2);
}

.accordion__caret {
  width: 1ch;
  display: inline-block;
  color: var(--text-muted);
}

.accordion__title {
  flex: 1;
}

.accordion__body {
  padding: 4px 4px 12px 24px;
}

.preview-empty-row {
  color: var(--text-muted);
}

.channel-summary {
  width: 100%;
  border-collapse: collapse;
  font-size: 12px;
}

.channel-summary th,
.channel-summary td {
  padding: 4px 8px;
  border-bottom: 1px solid var(--border);
  text-align: left;
  vertical-align: top;
}

.channel-summary th {
  color: var(--text-muted);
  font-weight: 500;
}

.download-btn {
  font-size: 14px;
}

.settings-modal__backdrop {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 100;
}

.settings-modal {
  background: var(--surface);
  border: 1px solid var(--border);
  border-radius: var(--radius);
  padding: 16px;
  width: min(560px, 92vw);
  max-height: 88vh;
  display: flex;
  flex-direction: column;
  box-shadow: var(--shadow);
}

.settings-modal__head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  margin-bottom: 8px;
}

.settings-modal__title {
  margin: 0;
  font-size: 16px;
  font-weight: 600;
}

.settings-modal__close {
  font-size: 18px;
  line-height: 1;
  padding: 4px 10px;
}

.settings-modal__tabs {
  display: flex;
  gap: 4px;
  border-bottom: 1px solid var(--border);
  margin-bottom: 12px;
}

.settings-modal__tab {
  background: transparent;
  border: none;
  color: var(--text-muted);
  padding: 8px 12px;
  cursor: pointer;
  font-size: 13px;
  border-bottom: 2px solid transparent;
}

.settings-modal__tab--active {
  color: var(--text);
  border-bottom-color: var(--accent);
}

.settings-modal__body {
  overflow: auto;
  flex: 1;
  padding: 4px 0;
}

.settings-modal__foot {
  display: flex;
  justify-content: flex-end;
  padding-top: 8px;
  border-top: 1px solid var(--border);
  margin-top: 8px;
}

.settings-section {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.settings-row {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;
  font-size: 13px;
}

.settings-row__label {
  min-width: 110px;
  color: var(--text-muted);
}

.settings-row__input {
  flex: 1 1 220px;
  min-width: 0;
  padding: 4px 6px;
  background: var(--bg);
  color: var(--text);
  border: 1px solid var(--border);
  border-radius: 4px;
  font-family: ui-monospace, SFMono-Regular, Menlo, Consolas, monospace;
  font-size: 12px;
}

.chip-list {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
}

.chip {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 4px 4px 4px 8px;
  background: var(--surface-2);
  border: 1px solid var(--border);
  border-radius: 999px;
  font-size: 12px;
}

.chip__label {
  display: inline-flex;
  align-items: baseline;
  gap: 4px;
}

.chip__name {
  color: var(--text-muted);
  font-size: 11px;
}

.chip__remove {
  background: transparent;
  border: none;
  color: var(--text-muted);
  cursor: pointer;
  font-size: 12px;
  padding: 0 6px;
}

.chip__remove:hover {
  color: var(--error);
}

.cc-add {
  display: flex;
  gap: 6px;
  align-items: center;
}

.cc-add-input {
  flex: 1 1 100px;
  padding: 4px 6px;
  background: var(--bg);
  color: var(--text);
  border: 1px solid var(--border);
  border-radius: 4px;
  font-size: 12px;
  font-family: ui-monospace, SFMono-Regular, Menlo, Consolas, monospace;
}

/* Аккордион «Каналы» над piano roll */
.pr-channels {
  margin-bottom: 8px;
  border: 1px solid var(--border);
  border-radius: var(--radius);
  overflow: hidden;
}

.pr-channels__head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  padding: 6px 10px;
  background: var(--surface);
  color: var(--text);
  border: none;
  font: inherit;
  font-size: 13px;
  cursor: pointer;
}

.pr-channels__head:hover {
  background: var(--surface-2);
}

.pr-channels__chips {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
  padding: 8px 10px;
  border-top: 1px solid var(--border);
}

.pr-channels .chip {
  padding: 4px 10px;
  cursor: pointer;
  border: 1px solid var(--border);
  background: var(--surface-2);
  color: var(--text);
  border-radius: 999px;
  font-size: 12px;
}

.pr-channels .chip:disabled {
  opacity: 0.45;
  cursor: not-allowed;
}

.pr-channels .chip--active {
  border-color: var(--accent);
  background: color-mix(in srgb, var(--accent) 22%, var(--surface-2));
  color: var(--text);
}

.pr-channels__chip {
  display: inline-flex;
  align-items: center;
  gap: 6px;
}

.chip__dot {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  display: inline-block;
  flex: none;
}

.chip__select {
  max-width: 170px;
  padding: 2px 4px;
  background: var(--bg);
  color: var(--text);
  border: 1px solid var(--border);
  border-radius: 4px;
  font-size: 11px;
  font-family: inherit;
}

.chip__select:disabled {
  opacity: 0.5;
}

.chip__drum {
  color: var(--text-muted);
  font-size: 11px;
  white-space: nowrap;
}

.chip__count {
  font-size: 10px;
  font-variant-numeric: tabular-nums;
}

/* Полноэкранный оверлей предзагрузки SoundFont: блокирует UI, показывает
   прогресс скачивания. z-index выше модалки настроек (.settings-modal__backdrop
   = 100). Контент приложения дополнительно получает \`inert\` (см. App.tsx). */
.sf-loading-overlay {
  position: fixed;
  inset: 0;
  z-index: 200;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(15, 17, 21, 0.55);
}

.sf-loading-overlay__card {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 12px;
  width: min(420px, 88vw);
  padding: 24px;
  background: var(--surface);
  border: 1px solid var(--border);
  border-radius: var(--radius);
  box-shadow: var(--shadow);
}

.sf-loading-overlay__spinner {
  width: 36px;
  height: 36px;
  border: 3px solid var(--border);
  border-top-color: var(--accent);
  border-radius: 50%;
  animation: sf-spin 0.9s linear infinite;
}

@keyframes sf-spin {
  to {
    transform: rotate(360deg);
  }
}

.sf-loading-overlay__title {
  margin: 0;
  font-size: 15px;
  font-weight: 600;
  text-align: center;
  overflow-wrap: anywhere;
}

.sf-loading-overlay__bar {
  width: 100%;
  height: 10px;
  border-radius: 999px;
  background: var(--surface-2);
  border: 1px solid var(--border);
  overflow: hidden;
}

.sf-loading-overlay__fill {
  height: 100%;
  border-radius: 999px;
  background: var(--accent);
  transition: width 0.15s ease;
}

.sf-loading-overlay__meta {
  margin: 0;
  color: var(--text-muted);
  font-size: 12px;
  font-variant-numeric: tabular-nums;
}

`, "",{"version":3,"sources":["webpack://./app/src/styles/app.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,kBAAkB;EAClB,oBAAoB;EACpB,iBAAiB;EACjB,eAAe;EACf,qBAAqB;EACrB,iBAAiB;EACjB,oBAAoB;EACpB,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;EAClB,aAAa;EACb,2CAA2C;EAC3C;;4DAE0D;EAC1D,mBAAmB;AACrB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,SAAS;EACT,UAAU;EACV,qBAAqB;EACrB,kBAAkB;EAClB,gGAAgG;EAChG,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,SAAS;EACT,oCAAoC;AACtC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,SAAS;EACT,wBAAwB;AAC1B;;AAEA;EACE,qBAAqB;EACrB,eAAe;EACf,gBAAgB;EAChB,+BAA+B;EAC/B,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,wBAAwB;EACxB,gBAAgB;AAClB;;AAEA;;kEAEkE;AAClE;EACE,yBAAyB;EACzB,2BAA2B;EAC3B,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,kBAAkB;EAClB,0BAA0B;EAC1B,+BAA+B;EAC/B,4BAA4B;AAC9B;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE;IACE,0BAA0B;EAC5B;AACF;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,kBAAkB;EAClB,0BAA0B;EAC1B,gCAAgC;EAChC,4BAA4B;EAC5B,kBAAkB;EAClB,mCAAmC;AACrC;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,YAAY;EACZ,oBAAoB;AACtB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,SAAS;EACT,wBAAwB;EACxB,eAAe;AACjB;;AAEA;EACE,0BAA0B;EAC1B,+BAA+B;EAC/B,4BAA4B;EAC5B,aAAa;EACb,yBAAyB;AAC3B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,wBAAwB;EACxB,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,gCAAgC;EAChC,aAAa;EACb,SAAS;AACX;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,wBAAwB;EACxB,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,iBAAiB;EACjB,qCAAqC;EACrC,+DAA+D;EAC/D,kBAAkB;EAClB,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,UAAU;EACV,gBAAgB;EAChB,wBAAwB;EACxB,eAAe;AACjB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,eAAe;AACjB;;AAEA;;EAEE,gBAAgB;EAChB,gBAAgB;EAChB,sCAAsC;EACtC,mBAAmB;AACrB;;AAEA;EACE,wBAAwB;EACxB,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,wBAAwB;EACxB,4BAA4B;AAC9B;;AAEA;EACE,wBAAwB;EACxB,eAAe;AACjB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,iBAAiB;EACjB,+BAA+B;EAC/B,4BAA4B;EAC5B,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,qBAAqB;EACrB,oBAAoB;EACpB,0DAA0D;AAC5D;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,2BAA2B;EAC3B,uBAAuB;AACzB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,kBAAkB;EAClB,4BAA4B;EAC5B,+BAA+B;EAC/B,0BAA0B;AAC5B;;AAEA;EACE,0BAA0B;EAC1B,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,6BAA6B;EAC7B,uBAAuB;EACvB,+BAA+B;EAC/B,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;EACf,cAAc;EACd,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,sBAAsB;EACtB,uBAAuB;EACvB,QAAQ;AACV;;AAEA;EACE,wBAAwB;EACxB,eAAe;EACf,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;;EAEE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,UAAU;EACV,qBAAqB;EACrB,wBAAwB;AAC1B;;AAEA;EACE,OAAO;AACT;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,eAAe;AACjB;;AAEA;;EAEE,gBAAgB;EAChB,sCAAsC;EACtC,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,wBAAwB;EACxB,gBAAgB;AAClB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,QAAQ;EACR,8BAA8B;EAC9B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;AACd;;AAEA;EACE,0BAA0B;EAC1B,+BAA+B;EAC/B,4BAA4B;EAC5B,aAAa;EACb,uBAAuB;EACvB,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,sCAAsC;EACtC,mBAAmB;AACrB;;AAEA;EACE,uBAAuB;EACvB,YAAY;EACZ,wBAAwB;EACxB,iBAAiB;EACjB,eAAe;EACf,eAAe;EACf,oCAAoC;AACtC;;AAEA;EACE,kBAAkB;EAClB,kCAAkC;AACpC;;AAEA;EACE,cAAc;EACd,OAAO;EACP,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,gBAAgB;EAChB,mCAAmC;EACnC,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,wBAAwB;AAC1B;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,gBAAgB;EAChB,qBAAqB;EACrB,kBAAkB;EAClB,+BAA+B;EAC/B,kBAAkB;EAClB,qEAAqE;EACrE,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,QAAQ;AACV;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,wBAAwB;EACxB,4BAA4B;EAC5B,+BAA+B;EAC/B,oBAAoB;EACpB,eAAe;AACjB;;AAEA;EACE,oBAAoB;EACpB,qBAAqB;EACrB,QAAQ;AACV;;AAEA;EACE,wBAAwB;EACxB,eAAe;AACjB;;AAEA;EACE,uBAAuB;EACvB,YAAY;EACZ,wBAAwB;EACxB,eAAe;EACf,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,kBAAkB;EAClB,+BAA+B;EAC/B,kBAAkB;EAClB,eAAe;EACf,qEAAqE;AACvE;;AAEA,sCAAsC;AACtC;EACE,kBAAkB;EAClB,+BAA+B;EAC/B,4BAA4B;EAC5B,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,WAAW;EACX,iBAAiB;EACjB,0BAA0B;EAC1B,kBAAkB;EAClB,YAAY;EACZ,aAAa;EACb,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,aAAa;EACb,eAAe;EACf,QAAQ;EACR,iBAAiB;EACjB,mCAAmC;AACrC;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,+BAA+B;EAC/B,4BAA4B;EAC5B,kBAAkB;EAClB,oBAAoB;EACpB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,2BAA2B;EAC3B,mEAAmE;EACnE,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,qBAAqB;EACrB,UAAU;AACZ;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,qBAAqB;EACrB,kBAAkB;EAClB,+BAA+B;EAC/B,kBAAkB;EAClB,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,wBAAwB;EACxB,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,kCAAkC;AACpC;;AAEA;;6EAE6E;AAC7E;EACE,eAAe;EACf,QAAQ;EACR,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kCAAkC;AACpC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,SAAS;EACT,uBAAuB;EACvB,aAAa;EACb,0BAA0B;EAC1B,+BAA+B;EAC/B,4BAA4B;EAC5B,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,+BAA+B;EAC/B,+BAA+B;EAC/B,kBAAkB;EAClB,uCAAuC;AACzC;;AAEA;EACE;IACE,yBAAyB;EAC3B;AACF;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,4BAA4B;EAC5B,+BAA+B;EAC/B,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,oBAAoB;EACpB,yBAAyB;EACzB,4BAA4B;AAC9B;;AAEA;EACE,SAAS;EACT,wBAAwB;EACxB,eAAe;EACf,kCAAkC;AACpC","sourcesContent":[":root {\n  --bg: #f5f7fb;\n  --surface: #ffffff;\n  --surface-2: #f0f3f9;\n  --border: #d8dde6;\n  --text: #1a1f2c;\n  --text-muted: #5d6679;\n  --accent: #2f6bff;\n  --accent-fg: #ffffff;\n  --error: #d92d2d;\n  --success: #16a34a;\n  --warning: #b97a00;\n  --radius: 8px;\n  --shadow: 0 4px 14px rgba(20, 30, 60, 0.08);\n  /* Единственная (светлая) цветовая схема: тёмная тема и адаптация по\n     prefers-color-scheme убраны. Цвета piano roll — константы\n     `PIANO_ROLL_COLORS` (см. app/src/pianoRollColors.ts). */\n  color-scheme: light;\n}\n\n* {\n  box-sizing: border-box;\n}\n\nhtml, body {\n  margin: 0;\n  padding: 0;\n  background: var(--bg);\n  color: var(--text);\n  font-family: -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, \"Helvetica Neue\", sans-serif;\n  font-size: 14px;\n  line-height: 1.5;\n}\n\n#root {\n  min-height: 100vh;\n}\n\n.app {\n  width: 100%;\n  margin: 0;\n  padding: 24px clamp(16px, 4vw, 48px);\n}\n\n.app__header {\n  margin-bottom: 24px;\n}\n\n.app__header h1 {\n  margin: 0 0 4px;\n  font-size: 24px;\n  font-weight: 700;\n}\n\n.app__header p {\n  margin: 0;\n  color: var(--text-muted);\n}\n\n.app__version {\n  display: inline-block;\n  margin-top: 6px;\n  padding: 2px 8px;\n  border: 1px solid var(--border);\n  border-radius: 999px;\n  font-size: 11px;\n  line-height: 1.4;\n  color: var(--text-muted);\n  user-select: all;\n}\n\n/* Dev-сборка (`webpack serve --mode development`): плашка инвертирована,\n   чтобы визуально отличать dev от prod. Модификатор вешается в App.tsx\n   по `IS_DEV` из config.ts (DefinePlugin → process.env.IS_DEV). */\n.app__version--dev {\n  background: var(--accent);\n  border-color: var(--accent);\n  color: var(--accent-fg);\n}\n\n.app__main {\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n}\n\n.app__results {\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n}\n\n.app__results-head {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  justify-content: space-between;\n  gap: 12px;\n  padding: 12px 16px;\n  background: var(--surface);\n  border: 1px solid var(--border);\n  border-radius: var(--radius);\n}\n\n.app__results-actions {\n  display: flex;\n  gap: 8px;\n  flex-wrap: wrap;\n}\n\n.app__grid {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 16px;\n}\n\n@media (max-width: 1024px) {\n  .app__grid {\n    grid-template-columns: 1fr;\n  }\n}\n\n.dropzone {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n  padding: 48px 24px;\n  background: var(--surface);\n  border: 2px dashed var(--border);\n  border-radius: var(--radius);\n  text-align: center;\n  transition: border-color 0.15s ease;\n}\n\n.dropzone--hover {\n  border-color: var(--accent);\n}\n\n.dropzone--disabled {\n  opacity: 0.7;\n  pointer-events: none;\n}\n\n.dropzone__title {\n  margin: 0;\n  font-size: 16px;\n  font-weight: 500;\n}\n\n.dropzone__hint {\n  margin: 0;\n  color: var(--text-muted);\n  font-size: 13px;\n}\n\n.card {\n  background: var(--surface);\n  border: 1px solid var(--border);\n  border-radius: var(--radius);\n  padding: 16px;\n  box-shadow: var(--shadow);\n}\n\n.card--highlight {\n  border-color: var(--accent);\n}\n\n.card__title {\n  margin: 0 0 12px;\n  font-size: 14px;\n  font-weight: 600;\n  color: var(--text-muted);\n  text-transform: uppercase;\n  letter-spacing: 0.04em;\n}\n\n.kv {\n  display: grid;\n  grid-template-columns: 110px 1fr;\n  gap: 4px 12px;\n  margin: 0;\n}\n\n.kv dt {\n  color: var(--text-muted);\n}\n\n.kv dd {\n  margin: 0;\n}\n\n.kv__hint {\n  color: var(--text-muted);\n  font-size: 12px;\n}\n\n.kv__diff {\n  grid-column: 2;\n  margin: 4px 0 0;\n  padding: 6px 10px;\n  border-left: 3px solid var(--warning);\n  background: color-mix(in srgb, var(--warning) 10%, transparent);\n  color: var(--text);\n  font-size: 13px;\n  border-radius: 4px;\n}\n\n.kv__alts {\n  grid-column: 2;\n  margin: 4px 0 0;\n  padding: 0;\n  list-style: none;\n  color: var(--text-muted);\n  font-size: 12px;\n}\n\n.table-wrap {\n  overflow-x: auto;\n}\n\n.track-table {\n  width: 100%;\n  border-collapse: collapse;\n  font-size: 13px;\n}\n\n.track-table th,\n.track-table td {\n  padding: 6px 8px;\n  text-align: left;\n  border-bottom: 1px solid var(--border);\n  vertical-align: top;\n}\n\n.track-table th {\n  color: var(--text-muted);\n  font-weight: 500;\n  font-size: 12px;\n  text-transform: uppercase;\n  letter-spacing: 0.04em;\n}\n\n.track-row--empty {\n  color: var(--text-muted);\n  background: var(--surface-2);\n}\n\n.muted {\n  color: var(--text-muted);\n  font-size: 12px;\n}\n\n.btn {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 6px;\n  padding: 8px 14px;\n  border: 1px solid var(--border);\n  background: var(--surface-2);\n  color: var(--text);\n  border-radius: 6px;\n  font-size: 13px;\n  cursor: pointer;\n  text-decoration: none;\n  font-family: inherit;\n  transition: background 0.15s ease, border-color 0.15s ease;\n}\n\n.btn:hover:not(:disabled) {\n  border-color: var(--accent);\n}\n\n.btn:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n.btn--primary {\n  background: var(--accent);\n  border-color: var(--accent);\n  color: var(--accent-fg);\n}\n\n.btn--primary:hover:not(:disabled) {\n  filter: brightness(1.1);\n}\n\n.btn--ghost {\n  background: transparent;\n}\n\n.banner {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 12px;\n  padding: 10px 14px;\n  border-radius: var(--radius);\n  border: 1px solid var(--border);\n  background: var(--surface);\n}\n\n.banner--error {\n  border-color: var(--error);\n  color: var(--error);\n}\n\n.gear-icon {\n  position: absolute;\n  top: 24px;\n  right: clamp(16px, 4vw, 48px);\n  background: transparent;\n  border: 1px solid var(--border);\n  border-radius: 6px;\n  padding: 6px 10px;\n  font-size: 18px;\n  line-height: 1;\n  cursor: pointer;\n  color: var(--text);\n}\n\n.gear-icon:hover {\n  border-color: var(--accent);\n}\n\n.app__header {\n  position: relative;\n}\n\n.op-toolbar {\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n}\n\n.op-toolbar__row {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  flex-wrap: wrap;\n}\n\n.op-toolbar__row--column {\n  flex-direction: column;\n  align-items: flex-start;\n  gap: 6px;\n}\n\n.op-toolbar__group-label {\n  color: var(--text-muted);\n  font-size: 12px;\n  text-transform: uppercase;\n  letter-spacing: 0.04em;\n}\n\n.op-toolbar__toggle,\n.op-toolbar__check {\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  font-size: 13px;\n  cursor: pointer;\n}\n\n.accordion__item {\n  border-top: 1px solid var(--border);\n}\n\n.accordion__item:first-child {\n  border-top: none;\n}\n\n.accordion__item--empty .accordion__title {\n  color: var(--text-muted);\n}\n\n.accordion__head {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  padding: 8px 4px;\n  cursor: pointer;\n  user-select: none;\n}\n\n.accordion__head:hover {\n  background: var(--surface-2);\n}\n\n.accordion__caret {\n  width: 1ch;\n  display: inline-block;\n  color: var(--text-muted);\n}\n\n.accordion__title {\n  flex: 1;\n}\n\n.accordion__body {\n  padding: 4px 4px 12px 24px;\n}\n\n.preview-empty-row {\n  color: var(--text-muted);\n}\n\n.channel-summary {\n  width: 100%;\n  border-collapse: collapse;\n  font-size: 12px;\n}\n\n.channel-summary th,\n.channel-summary td {\n  padding: 4px 8px;\n  border-bottom: 1px solid var(--border);\n  text-align: left;\n  vertical-align: top;\n}\n\n.channel-summary th {\n  color: var(--text-muted);\n  font-weight: 500;\n}\n\n.download-btn {\n  font-size: 14px;\n}\n\n.settings-modal__backdrop {\n  position: fixed;\n  inset: 0;\n  background: rgba(0, 0, 0, 0.5);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 100;\n}\n\n.settings-modal {\n  background: var(--surface);\n  border: 1px solid var(--border);\n  border-radius: var(--radius);\n  padding: 16px;\n  width: min(560px, 92vw);\n  max-height: 88vh;\n  display: flex;\n  flex-direction: column;\n  box-shadow: var(--shadow);\n}\n\n.settings-modal__head {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 12px;\n  margin-bottom: 8px;\n}\n\n.settings-modal__title {\n  margin: 0;\n  font-size: 16px;\n  font-weight: 600;\n}\n\n.settings-modal__close {\n  font-size: 18px;\n  line-height: 1;\n  padding: 4px 10px;\n}\n\n.settings-modal__tabs {\n  display: flex;\n  gap: 4px;\n  border-bottom: 1px solid var(--border);\n  margin-bottom: 12px;\n}\n\n.settings-modal__tab {\n  background: transparent;\n  border: none;\n  color: var(--text-muted);\n  padding: 8px 12px;\n  cursor: pointer;\n  font-size: 13px;\n  border-bottom: 2px solid transparent;\n}\n\n.settings-modal__tab--active {\n  color: var(--text);\n  border-bottom-color: var(--accent);\n}\n\n.settings-modal__body {\n  overflow: auto;\n  flex: 1;\n  padding: 4px 0;\n}\n\n.settings-modal__foot {\n  display: flex;\n  justify-content: flex-end;\n  padding-top: 8px;\n  border-top: 1px solid var(--border);\n  margin-top: 8px;\n}\n\n.settings-section {\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n}\n\n.settings-row {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  flex-wrap: wrap;\n  font-size: 13px;\n}\n\n.settings-row__label {\n  min-width: 110px;\n  color: var(--text-muted);\n}\n\n.settings-row__input {\n  flex: 1 1 220px;\n  min-width: 0;\n  padding: 4px 6px;\n  background: var(--bg);\n  color: var(--text);\n  border: 1px solid var(--border);\n  border-radius: 4px;\n  font-family: ui-monospace, SFMono-Regular, Menlo, Consolas, monospace;\n  font-size: 12px;\n}\n\n.chip-list {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 6px;\n}\n\n.chip {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  padding: 4px 4px 4px 8px;\n  background: var(--surface-2);\n  border: 1px solid var(--border);\n  border-radius: 999px;\n  font-size: 12px;\n}\n\n.chip__label {\n  display: inline-flex;\n  align-items: baseline;\n  gap: 4px;\n}\n\n.chip__name {\n  color: var(--text-muted);\n  font-size: 11px;\n}\n\n.chip__remove {\n  background: transparent;\n  border: none;\n  color: var(--text-muted);\n  cursor: pointer;\n  font-size: 12px;\n  padding: 0 6px;\n}\n\n.chip__remove:hover {\n  color: var(--error);\n}\n\n.cc-add {\n  display: flex;\n  gap: 6px;\n  align-items: center;\n}\n\n.cc-add-input {\n  flex: 1 1 100px;\n  padding: 4px 6px;\n  background: var(--bg);\n  color: var(--text);\n  border: 1px solid var(--border);\n  border-radius: 4px;\n  font-size: 12px;\n  font-family: ui-monospace, SFMono-Regular, Menlo, Consolas, monospace;\n}\n\n/* Аккордион «Каналы» над piano roll */\n.pr-channels {\n  margin-bottom: 8px;\n  border: 1px solid var(--border);\n  border-radius: var(--radius);\n  overflow: hidden;\n}\n\n.pr-channels__head {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  width: 100%;\n  padding: 6px 10px;\n  background: var(--surface);\n  color: var(--text);\n  border: none;\n  font: inherit;\n  font-size: 13px;\n  cursor: pointer;\n}\n\n.pr-channels__head:hover {\n  background: var(--surface-2);\n}\n\n.pr-channels__chips {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 6px;\n  padding: 8px 10px;\n  border-top: 1px solid var(--border);\n}\n\n.pr-channels .chip {\n  padding: 4px 10px;\n  cursor: pointer;\n  border: 1px solid var(--border);\n  background: var(--surface-2);\n  color: var(--text);\n  border-radius: 999px;\n  font-size: 12px;\n}\n\n.pr-channels .chip:disabled {\n  opacity: 0.45;\n  cursor: not-allowed;\n}\n\n.pr-channels .chip--active {\n  border-color: var(--accent);\n  background: color-mix(in srgb, var(--accent) 22%, var(--surface-2));\n  color: var(--text);\n}\n\n.pr-channels__chip {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n}\n\n.chip__dot {\n  width: 8px;\n  height: 8px;\n  border-radius: 50%;\n  display: inline-block;\n  flex: none;\n}\n\n.chip__select {\n  max-width: 170px;\n  padding: 2px 4px;\n  background: var(--bg);\n  color: var(--text);\n  border: 1px solid var(--border);\n  border-radius: 4px;\n  font-size: 11px;\n  font-family: inherit;\n}\n\n.chip__select:disabled {\n  opacity: 0.5;\n}\n\n.chip__drum {\n  color: var(--text-muted);\n  font-size: 11px;\n  white-space: nowrap;\n}\n\n.chip__count {\n  font-size: 10px;\n  font-variant-numeric: tabular-nums;\n}\n\n/* Полноэкранный оверлей предзагрузки SoundFont: блокирует UI, показывает\n   прогресс скачивания. z-index выше модалки настроек (.settings-modal__backdrop\n   = 100). Контент приложения дополнительно получает `inert` (см. App.tsx). */\n.sf-loading-overlay {\n  position: fixed;\n  inset: 0;\n  z-index: 200;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: rgba(15, 17, 21, 0.55);\n}\n\n.sf-loading-overlay__card {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 12px;\n  width: min(420px, 88vw);\n  padding: 24px;\n  background: var(--surface);\n  border: 1px solid var(--border);\n  border-radius: var(--radius);\n  box-shadow: var(--shadow);\n}\n\n.sf-loading-overlay__spinner {\n  width: 36px;\n  height: 36px;\n  border: 3px solid var(--border);\n  border-top-color: var(--accent);\n  border-radius: 50%;\n  animation: sf-spin 0.9s linear infinite;\n}\n\n@keyframes sf-spin {\n  to {\n    transform: rotate(360deg);\n  }\n}\n\n.sf-loading-overlay__title {\n  margin: 0;\n  font-size: 15px;\n  font-weight: 600;\n  text-align: center;\n  overflow-wrap: anywhere;\n}\n\n.sf-loading-overlay__bar {\n  width: 100%;\n  height: 10px;\n  border-radius: 999px;\n  background: var(--surface-2);\n  border: 1px solid var(--border);\n  overflow: hidden;\n}\n\n.sf-loading-overlay__fill {\n  height: 100%;\n  border-radius: 999px;\n  background: var(--accent);\n  transition: width 0.15s ease;\n}\n\n.sf-loading-overlay__meta {\n  margin: 0;\n  color: var(--text-muted);\n  font-size: 12px;\n  font-variant-numeric: tabular-nums;\n}\n\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
